
import React, { useState } from 'react';
import {TextField, Button, ThemeProvider} from '@mui/material';
import {THEME} from "../../theme/PacsTheme";

import "../../App.css";
import "./FeedbackForm.css";
import {isValidEmail} from "../../util/Validators";
import {net_sendFeedback} from "../../net/FeedbackCalls";

export default function FeedbackForm(props) {

    const goSuccess = props.onSuccess;
    const [formData, setFormData] = useState({
        email: '',
        feedback: ''
    });

    const [errors, setErrors] = useState({
        error: false,
        errorText: "Email Address is not valid"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleBlur = (e) => {
        setErrors({...errors, error: !isValidEmail(formData.email)});
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        net_sendFeedback(formData, (response) => {
            if (response.code === 200) {
                goSuccess();
            }
        }, error => {
            console.warn(error.message);
        })
    }

    return (
        <div
            style={{
                padding: "20px"
            }}
        >
            <div>
                <TextField
                    label="Email Address"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.error}
                    helperText={errors.error ? errors.errorText : ""}
                    fullWidth
                    required
                />
            </div>
            <div className={"default-margin-top-medium"}>
                <TextField
                    label="Feedback"
                    name="feedback"
                    multiline
                    minRows={6}
                    value={formData.feedback}
                    onChange={handleChange}
                    fullWidth
                    required
                />
            </div>
            <div className={"default-text-align-center default-margin-top-medium default-display-flex"}>
                <ThemeProvider theme={THEME}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            width: "120px",
                            marginRight: "5px"
                        }}
                        onClick={props.onClose}
                    >
                        <span style={{fontFamily: "Lato sans-serif"}}>CANCEL</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            marginLeft: "5px",
                            width: "120px"
                        }}
                        onClick={handleSubmit}
                    >
                        <span style={{fontFamily: "Lato sans-serif"}}>SUBMIT</span>
                    </Button>
                </ThemeProvider>
            </div>
        </div>
    );
}

